
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 56 56","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M49.474 0H6.526a4.927 4.927 0 00-4.922 4.922v41.194A4.91 4.91 0 003.21 49.75v4.61c0 .906.734 1.641 1.64 1.641h46.3a1.64 1.64 0 001.64-1.64v-4.61a4.91 4.91 0 001.605-3.634V4.922A4.927 4.927 0 0049.474 0zM4.886 4.922c0-.905.736-1.64 1.64-1.64h14.372v9.491H4.886V4.922zm44.623 47.797H6.491v-1.682l.035.001H49.51v1.68zm1.605-6.603c0 .905-.736 1.641-1.64 1.641H6.526c-.904 0-1.64-.736-1.64-1.64V16.053h46.228v30.062zm0-33.343H24.18V3.281h25.294c.904 0 1.64.736 1.64 1.64v7.852z","fill":"#6C7177"}}),_c('path',{attrs:{"d":"M39.835 27.19h-.998c-1.821-5.048-6.66-8.667-12.327-8.667-7.223 0-13.1 5.877-13.1 13.1s5.877 13.1 13.1 13.1c5.668 0 10.506-3.62 12.327-8.667h.998a2.37 2.37 0 002.367-2.367v-4.132a2.37 2.37 0 00-2.367-2.367zM26.51 41.44c-5.414 0-9.818-4.404-9.818-9.817 0-5.414 4.404-9.818 9.818-9.818 3.82 0 7.136 2.192 8.759 5.385H34.13a4.434 4.434 0 000 8.866h1.138c-1.623 3.192-4.94 5.385-8.76 5.385zm12.41-8.666h-4.789a1.15 1.15 0 01-1.147-1.155c0-.633.515-1.148 1.147-1.148h4.79v2.303zM39.093 7.483h-1.981a1.64 1.64 0 000 3.281h1.981a1.64 1.64 0 000-3.281zM46.432 7.483H44.45a1.64 1.64 0 000 3.281h1.98a1.64 1.64 0 000-3.281z","fill":"#6C7177"}})])
          )
        }
      }
    